export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-3xl font-black text-fg mb-2">Пользовательское соглашение</h1>
      <p className="text-sm text-muted mb-10">vaumanga.com</p>

      <div className="flex flex-col gap-8">
        <Section title="1. Общие положения">
          <p>Используя сайт vaumanga.com, вы соглашаетесь с настоящим Пользовательским соглашением. Если вы не согласны с условиями — пожалуйста, не используйте сайт.</p>
          <p>Мы оставляем за собой право изменять условия соглашения. Продолжение использования сайта после изменений означает ваше согласие с обновлёнными условиями.</p>
        </Section>

        <Section title="2. Регистрация">
          <p>Для полного доступа к функциям сайта требуется регистрация. Вы обязуетесь:</p>
          <ul>
            <li>Указывать достоверные данные при регистрации</li>
            <li>Не передавать доступ к аккаунту третьим лицам</li>
            <li>Нести ответственность за все действия, совершённые с вашего аккаунта</li>
            <li>Незамедлительно сообщать нам о несанкционированном доступе к вашему аккаунту</li>
          </ul>
        </Section>

        <Section title="3. Правила поведения">
          <p>Пользователям запрещено:</p>
          <ul>
            <li>Публиковать оскорбления, угрозы, hate speech в комментариях</li>
            <li>Спамить и размещать рекламу без разрешения администрации</li>
            <li>Выдавать себя за других пользователей или администрацию</li>
            <li>Пытаться взломать или нарушить работу сайта</li>
            <li>Публиковать контент, нарушающий законодательство</li>
          </ul>
          <p>Мы вправе удалять комментарии и блокировать пользователей, нарушающих данные правила, без предупреждения.</p>
        </Section>

        <Section title="4. Контент сайта">
          <p>Весь контент на vaumanga.com (переводы, оформление, дизайн) предназначен исключительно для личного некоммерческого использования. Копирование и распространение контента без разрешения администрации запрещено.</p>
          <p>Мы уважаем права правообладателей. По запросу правообладателя контент будет удалён — подробнее в разделе <a href="/dmca" className="text-accent hover:underline">DMCA</a>.</p>
        </Section>

        <Section title="5. Донаты и платные функции">
          <p>В будущем на сайте могут появиться платные функции или возможность поддержать проект донатом. Все платежи будут добровольными. Подробные условия будут опубликованы при введении платных функций.</p>
        </Section>

        <Section title="6. Ограничение ответственности">
          <p>vaumanga.com предоставляется «как есть». Мы не гарантируем:</p>
          <ul>
            <li>Бесперебойную работу сайта</li>
            <li>Сохранность пользовательских данных в случае форс-мажора</li>
            <li>Что сайт будет доступен в любое время</li>
          </ul>
          <p>Мы не несём ответственности за ущерб, возникший в результате использования или невозможности использования сайта.</p>
        </Section>

        <Section title="7. Возраст">
          <p>Используя сайт, вы подтверждаете, что вам исполнилось 13 лет. Контент, помеченный как 18+, скрыт по умолчанию. Нажимая кнопку показа 18+ контента, вы подтверждаете, что являетесь совершеннолетним согласно законодательству вашей страны. Администрация не несёт ответственности за доступ несовершеннолетних к 18+ контенту, если они предоставили ложные сведения о своём возрасте.</p>
        </Section>

        <Section title="8. Блокировка">
          <p>Мы вправе заблокировать аккаунт или ограничить доступ к сайту без объяснения причин, если пользователь нарушает данное соглашение.</p>
        </Section>

        <Section title="9. Контакты">
          <p>По всем вопросам: <a href="mailto:dmca@vaumanga.com" className="text-accent hover:underline">dmca@vaumanga.com</a></p>
        </Section>
      </div>

      <p className="text-xs text-muted mt-12 pt-6 border-t border-line">Последнее обновление: май 2026</p>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-base font-bold text-accent">{title}</h2>
      <div className="flex flex-col gap-2 text-sm text-fg leading-relaxed [&_ul]:flex [&_ul]:flex-col [&_ul]:gap-1.5 [&_ul]:pl-1 [&_li]:flex [&_li]:gap-2 [&_li]:before:content-['—'] [&_li]:before:text-muted [&_li]:before:flex-shrink-0">
        {children}
      </div>
    </section>
  )
}
